<template>
    <div id="app">
        <PatientNotes :Mode="'View'" :Type="'1'"/>
    </div>
</template>

<script>
import Vue from 'vue';
import PatientNotes from '@/components/DPEBB/Administrator/PatientNotes.vue'
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';

export default {

  data: function (){
        return {
        AppServiceID :6,
        }
    },
    components: {
        Card,
        CardBody,
        TileNote,
        PatientNotes
    },
created: function() {

    this.$emit('update:layout', LayoutDefault);
},    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDentalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDentalID);
    },

}
</script>

<style>

</style>
